import { createProject } from '@/services/api';
import { IProject } from '@d-id/types';
import { useMutation, useQueryClient } from 'react-query';

export const useCreateProject = () => {
    const queryClient = useQueryClient();

    return useMutation(createProject, {
        onSuccess: async (project: IProject) => {
            // NOTE: If the project API is not yet updated, it returns an S3 raw_data_url, whereas getProject returns
            // pre-signed URLs. We need pre-signed URLs, so if we only get S3 URL here, then we don't cache the project
            // and have the getProject query re-fetch the project on next use.
            // However, if we get a pre-signed URL, then we can cache the project and avoid the re-fetch.

            if (project.raw_data_url?.startsWith('https://')) {
                queryClient.setQueryData(`get-project-${project.id}`, project);
            }
        },
    });
};
